module.exports = __webpack_public_path__ + "static/media/IMG_3568.6fce726b.jpg";